import React, { useContext } from 'react';

import PropTypes from 'prop-types';

import _get from 'lodash/get';
import { useSelector } from 'react-redux';

import { wrapActionChangeHandlers } from './Actions.utils';
import { isAdminUser } from '../../../../../../../libs/auth';
import { selectBusiness } from '../../../../../../../selectors';
import { selectUser } from '../../../../../../../selectors/user';
import { ActionsWidgetSectionsType } from '../../../../types/actions';
import ActionsWidget from '../../../ActionsWidget';
import { ActionsInputContext } from '../../ActionsInput.context';

const propTypes = {
  actionSections: ActionsWidgetSectionsType.isRequired,
  trigger: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  intelligentWebsiteOnly: PropTypes.bool,
  hide: PropTypes.bool,
  disabled: PropTypes.bool,
};

const defaultProps = {
  intelligentWebsiteOnly: false,
  hide: false,
  disabled: false,
};

export default function Actions({
  actionSections,
  trigger,
  intelligentWebsiteOnly,
  hide,
  disabled,
}) {
  const user = useSelector(selectUser);
  const business = useSelector(selectBusiness);
  const isAdmin = isAdminUser(user);
  const hasIntelligentWebsiteProduct = _get(business, 'hasIntelligentWebsiteProduct', false);

  const { input } = useContext(ActionsInputContext);

  if (intelligentWebsiteOnly && !isAdmin && !hasIntelligentWebsiteProduct) {
    return null;
  }

  if (hide) {
    return null;
  }

  const wrappedActionSections = wrapActionChangeHandlers(actionSections, input);

  return (
    <ActionsWidget actionSections={wrappedActionSections} trigger={trigger} disabled={disabled} />
  );
}

Actions.propTypes = propTypes;
Actions.defaultProps = defaultProps;
